// src/config/logos.js
const logos = {
    headerLogo: 'http://localhost:3000/images/logo/sunokahaniyanlogo.png',
    footerLogo: 'http://localhost:3000/images/logo/sunokahaniyanlogo.png',
  };
  
  export default logos;


  
  